import { render, staticRenderFns } from "./DeliveryContent.vue?vue&type=template&id=0ce186f8&"
import script from "./DeliveryContent.vue?vue&type=script&lang=js&"
export * from "./DeliveryContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports